import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="A" transform="translate(11.000000, 5.000000)">
        <path
          d="M41.5,30.3 L51.7,61 L45.7,61 L43.45,53.65 L32.05,53.65 L29.8,61 L24.1,61 L34.3,30.3 L41.5,30.3 Z M42.1,48.95 L37.75,35.5 L33.4,48.95 L42.1,48.95 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
